export default function AdminAuth(user) {
  return user != null;
}
